import {Component, OnInit} from '@angular/core';
import {AlertService} from '@comm-apps/alert';
import { AggridService, AutoUnsubscribables, AutoUnsubscriber } from '@comm-apps/common';
import {LogService} from '@comm-apps/log';
import 'ag-grid-enterprise';
import {AppSettings} from '../../../app.settings';
import * as _ from 'lodash-es';
import {cad} from '@comm-apps/common';
import TableState = cad.TableState;
import { UserRequestData, CodeData, Asset, AssetRole, CodeDataCheck } from '../../../core/classes/data-types';
import { CodeDataService } from '../../../services/code-data.service';
import { AccessRequestService } from '../../../services/access-request.service';
import { RecaptchaErrorParameters } from 'ng-recaptcha';

@Component({
  selector: 'car-enable-request',
  templateUrl: './enable-request.component.html',
  styleUrls: ['./enable-request.component.scss']
})
export class EnableComponent implements OnInit  {
  @AutoUnsubscriber()
  protected subs: AutoUnsubscribables;
  private readonly blankData: UserRequestData = {applicationCd: 'EN', roles:[], tsps:[],companies:[{}], actionCd: 'add'};

  // public actionOptions: any[] = [ {code:'add', description: 'Add User'}, 
  //                                 {code:'modify', description: 'Modify User'}, 
  //                                 {code:'remove', description: 'Remove User'}
  //                               ]

  public data:UserRequestData = _.cloneDeep(this.blankData);  
  public roles: CodeDataCheck[] = [];
  public tsps: CodeDataCheck[] = [];
  public states: CodeData[] = [];
  public submitting: boolean = false;
  public submitted: boolean = false;

  constructor(
    protected alertService: AlertService,
    protected appSettings: AppSettings,
    protected log: LogService,
    protected codeService: CodeDataService,
    protected accessRequestService: AccessRequestService,
    protected gridService: AggridService,
  ) {
  }

  public ngOnInit(): void {
    this.codeService.findByType('EN_TSP').subscribe({
      next: (codes) => { this.tsps = codes; }
    });
    this.codeService.findByType('EN_ROLE').subscribe({
      next: (codes) => { this.roles = codes; }
    });
    this.codeService.findByType('STATE').subscribe({
      next: (codes) => { this.states = codes; }
    });
  }

  /**
   * Translates the selected check boxes into arrays of values on different properties on the source data object
   * @param event Checkbox event that is fired
   * @param code code associated with the checkbox clicked
   * @param type type of checkbox this is - will be translated to the data objects list property.
   */
  public checkSelected(event: any, code: string, type:string) {
    const typeCd = `${type.slice(0, -1)}Cd`;
    if (event.checked) {
      this.data[type].push({[typeCd]: code});
    } else {
      _.remove(this.data[type], function(n) {return n[typeCd]===code} );
    }
  }

  public submit(): void {
    this.submitting = true;
    this.submitted = true;
    console.log('Recaptcha token is ', this.data.recaptchaToken);
    const propsToOmit = [];
    switch (this.data.actionCd) {
      case 'add':
        propsToOmit.push('userId');
        break;
      case 'remove':
        const props = ['email', 'phone', 'address', 'city', 'stateCd', 'zip', 'roles', 'tsps'];
        propsToOmit.push(...props);
    }
    
    const data: UserRequestData = _.omit(this.data, propsToOmit);
    if (data.actionCd == 'remove') {
      data.roles = [];
      data.tsps = [];
    }
    this.accessRequestService.savePublic(data).subscribe({
      error: () => {
        this.submitting = false;
        this.submitted = false;
      },
      complete: () => {
        this.submitting = false;
      }
    });
  }

  public clear(): void {
    const actionCd = this.data.actionCd;
    this.data = _.cloneDeep(this.blankData); 
    this.data.actionCd = actionCd;
    this.submitted = false;
    ['roles', 'tsps'].forEach(codeType => {
      this[codeType].forEach(code => {
        code.checked = false;
      })
    });
    window.scroll(0, 0);
  }

  public resolved(captchaResponse: string): void {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  public onError(errorDetails: RecaptchaErrorParameters): void {
    console.log(`reCAPTCHA error encountered; details:`, errorDetails);
  }

  public addCompany() {
    this.data.companies.push({ accessRequestId: this.data.id });
  }

  public deleteCompany(index: number) {
    this.data.companies.splice(index, 1);
  }



}
